import { CSSProperties } from 'react';
import chroma from 'chroma-js';

export const smartSceneThemeStyle = (theme: { mainColor: string; h1Color: string; h2Color: string; backgroundColor: string; componentColor?: string }, container?: { useThemeColor?: boolean; componentBg?: string }): CSSProperties => ({
  '--smart-primary': theme.mainColor,
  '--smart-text': theme.h1Color,
  '--smart-secondary': theme.h2Color,
  '--smart-panel-tint': container && container.useThemeColor === false
    ? container.componentBg || 'transparent'
    : container && container.useThemeColor === true
      ? theme.componentColor || 'transparent'
      : chroma(theme.mainColor).alpha(0.06).css()
} as CSSProperties);

export const smartSearchThemeStyle = (theme: any, container: any = {}): CSSProperties => {
  container = container || {};
  const background = container.useThemeColor === true ? theme.componentColor || 'transparent'
    : container.componentBg || 'transparent';
  const transparent = background === 'transparent' || (chroma.valid(background) && chroma(background).alpha() === 0);
  const radius = container.borderRadius;
  return {
    ...smartSceneThemeStyle(theme, container),
    '--smart-panel-tint': background,
    '--smart-panel-shadow': transparent ? 'none' : '0 2px 8px rgba(0,0,0,.06)',
    borderRadius: radius === undefined ? 0 : Number.isNaN(+radius) ? radius : +radius,
    paddingTop: 14 + (Number(container.paddingTop) || 0),
    paddingBottom: 14 + (Number(container.paddingBottom) || 0),
    paddingLeft: 14 + (Number(container.paddingLeft) || 0),
    paddingRight: 14 + (Number(container.paddingRight) || 0),
  } as CSSProperties;
};
